<template>
  <div class="return">
    <ArrowLeft :size="20" class="icon" />
    <p>{{ text ?? 'Annuler' }}</p>
  </div>
</template>

<script setup lang="ts">
import { ArrowLeft } from 'lucide-vue-next'

defineProps<{
  text?: string
}>()
</script>

<style scoped>
.icon {
  color: var(--vc-dark);
}

.return {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}

.return:hover {
  transition: 600ms cubic-bezier(0.19, 1, 0.22, 1);
  gap: 12px;
}
</style>
